import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm } from 'redux-form'
import PurchaseComponent from '../../../dossiers/purchase/PurchaseComponent'
import { dossierTypes as dossierTypesConstant } from '../../../../constants/dossier/common/dossierTypes'
import { dossierSubTypeId } from '../../../../constants/dossier/common/dossierSubType'

class DataPurchasesFleetModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  saveData (values) {
    let dossierList = this.props.dossiers.map(x => { return x.dossierId })
    if (values !== null && values !== undefined && values.dossierPurchaseComponent && (this.haveValues(values.dossierPurchaseComponent) || this.haveValues(values.dossierCompleteDeliveryComponent))) {
      this.props.actions.setOperateDataPurchaseFleetProcess(dossierList, values.dossierPurchaseComponent, values.dossierCompleteDeliveryComponent?.dossierDeliveryComponent, this.props.fleet.fleetId, () => this.props.actions.closeDataPurchasesFleetModal())
    } else {
      this.props.actions.openModal('notChangesToSave')
    }
  }

  haveValues (fields) {
    for (let key in fields) {
      if (fields[key] !== null && fields[key] !== undefined && fields[key] !== '') {
        if (Array.isArray(fields[key]) && fields[key].length > 0) {
          return true
        } else if (!Array.isArray(fields[key])) {
          return true
        }
      }
    }
    return false
  }

  componentDidUpdate () {
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.showModal &&
      !prevProps.showModal &&
      (
        this.props.dossier &&
        this.props.dossier.organizedUnitId &&
        (
          this.props.dossier.organizedUnitId !== prevProps.dossier?.organizedUnitId ||
          this.props.combos.salesmanCombo === undefined ||
          this.props.combos.salesmanCombo === null ||
          this.props.combos.salesmanCombo.length === 0
        )
      )) {
      this.props.actions.fetchSalesmanCombos(this.props.dossier.organizedUnitId)
    }

    if (this.props.showModal &&
      !prevProps.showModal &&
      (
        this.props.dossier.dossierSubType !== prevProps.dossier?.dossierSubType ||
        this.props.combos.purchaseTypeCombo === undefined ||
        this.props.combos.purchaseTypeCombo === null ||
        this.props.combos.purchaseTypeCombo.length === 0
      )) {
      this.props.actions.fetchPurchaseType(this.props.dossier.dossierSubType)
    }

    if (this.props.showModal &&
      !prevProps.showModal &&
      (
        this.props.combos.rentingEntityCombo === undefined ||
        this.props.combos.rentingEntityCombo === null ||
        this.props.combos.rentingEntityCombo.length === 0
      )) {
      this.props.actions.fetchRentingEntityCombo()
    }

    if (this.props.showModal &&
      !prevProps.showModal &&
      (
        this.props.combos.tuneUpDestinationCombo === undefined ||
        this.props.combos.tuneUpDestinationCombo === null ||
        this.props.combos.tuneUpDestinationCombo.length === 0
      )) {
      this.props.actions.fetchTuneUpDestination()
    }

    if (this.props.showModal &&
      !prevProps.showModal &&
      (
        this.props.combos.stockStatusCombo === undefined ||
        this.props.combos.stockStatusCombo === null ||
        this.props.combos.stockStatusCombo.length === 0
      )) {
      this.props.actions.fetchStockStatusCombo()
    }

    if (this.props.showModal &&
      !prevProps.showModal &&
      (
        this.props.combos.purchaseOrderTypeCombo === undefined ||
        this.props.combos.purchaseOrderTypeCombo === null ||
        this.props.combos.purchaseOrderTypeCombo.length === 0
      )) {
      this.props.actions.fetchPurchaseOrderTypeCombo()
    }

    if (this.props.showModal &&
      !prevProps.showModal &&
      (
        this.props.combos.saleTypeAllCombo === undefined ||
        this.props.combos.saleTypeAllCombo === null ||
        this.props.combos.saleTypeAllCombo.length === 0
      )) {
      this.props.actions.fetchSaleTypeAll()
    }

    if (this.props.showModal &&
      !prevProps.showModal &&
      (
        this.props.dossier.organizedUnitId !== prevProps.dossier?.organizedUnitId ||
        this.props.combos.puscharseSaleEntitys === undefined ||
        this.props.combos.puscharseSaleEntitys === null ||
        this.props.combos.puscharseSaleEntitys.length === 0
      )) {
      this.props.actions.fetchPuscharseSaleEntitys(this.props.dossier.organizedUnitId)
    }

    if (this.props.showModal && !prevProps.showModal) {
      this.props.initialize()
      this.props.actions.fetchOperateDataFleetModalsPermissions(this.props.dossier.dossierSubType, this.props.dossier.organizedUnitId, this.props.dossier.stageId)
    }
    return null
  }

  render () {
    const {
      t, showModal, handleSubmit, dossierPurchaseComponent,
      actions: {
        closeDataPurchasesFleetModal,
        printDeliveryChecklist,
        synchroniseAvailabilityDate,
        checkPurchaseTypeAndSetDefaultEntity,
        setActiveSection,
        openCommonModal
      },
      change, componentConfiguration, dossier, readOnlyFields,
      dossierId, dossierParentId, printDeliveryChecklistPermission,
      combos: {
        purchaseTypeCombo,
        rentingEntityCombo,
        tuneUpDestinationCombo,
        stockStatusCombo,
        purchaseOrderTypeCombo,
        salesmanCombo,
        saleTypeAllCombo,
        puscharseSaleEntitys
      }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.PURCHASE_DOSSIER.PURCHASE_COMPONENT.'

    if (showModal && componentConfiguration) {
      return (
        <Modal id='dataPurchasesFleetModal' className='_nf languages-modal fleet-created-select-modal' show={showModal} onHide={closeDataPurchasesFleetModal} backdrop={'static'}>
          <form className='formDataPurchasesFleet' autoComplete="off" onSubmit={handleSubmit((values) => this.saveData(values))}>
            <Modal.Header closeButton onHide={this.props.actions.closeActionDataModal}>
              <Modal.Title>  <i className="componentIcon ico-sales" />{t(`${tKey}TITLE`)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <PurchaseComponent
                t={t}
                showNewVehicleFields={dossier.dossierSubType === dossierSubTypeId.compra_vn}
                combos={{ purchaseTypeCombo, rentingEntityCombo, tuneUpDestinationCombo, stockStatusCombo, purchaseOrderTypeCombo, salesmanCombo, saleTypeAllCombo, puscharseSaleEntitys }}
                actions={{
                  printDeliveryChecklist,
                  synchroniseAvailabilityDate,
                  checkPurchaseTypeAndSetDefaultEntity,
                  setActiveSection,
                  openCommonModal
                }}
                organizedUnitId={dossier.organizedUnitId}
                readOnlyFields={readOnlyFields}
                purchaseOpen={true}
                dossierType={dossierTypesConstant.fleetFinder}
                dossierSubType={dossier.dossierSubType}
                dossierId={dossierId}
                printDeliveryChecklistPermission={printDeliveryChecklistPermission}
                componentConfiguration={componentConfiguration}
                hasParent={!!dossierParentId}
                purchaseTypeId={dossierPurchaseComponent?.purchaseTypeId}
                change={change}
                dossier = {dossier}
              />

            </Modal.Body>
            <Modal.Footer>
              <Col sm={12} className='flexInLine al-C'>
                <Button
                  id="dataSalesFleet_btn_search"
                  className="_Btn new"
                  type='submit'
                  disabled={this.props.pristine}>
                  {t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.SAVE')}
                </Button>
                <Button
                  id='btn-close-fleet-created-select-charge-modal'
                  className="_Btn cancel"
                  onClick={() => closeDataPurchasesFleetModal()}>
                  {t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.EXIT')}
                </Button>
              </Col>
            </Modal.Footer>
          </form>
        </Modal>

      )
    } else {
      return null
    }
  }
}

export default reduxForm({
  form: 'dataPurchasesFleetModal'
})(DataPurchasesFleetModal)
